<div class="confirmation-dialog">
  <div class="dialog-header">
    <mat-icon [style.color]="data.iconColor" class="dialog-icon">{{ data.icon }}</mat-icon>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>

  <mat-dialog-content>
    <div class="messages-container">
      <ul class="messages-list">
        <li *ngFor="let message of data.messagesArray" class="message-item">
          <mat-icon class="message-icon">info_outline</mat-icon>
          <span>{{ message }}</span>
        </li>
      </ul>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onCancel()" class="cancel-button">
      <mat-icon>close</mat-icon>
      {{ data.cancelText }}
    </button>
    <button mat-flat-button (click)="onConfirm()" class="confirm-button">
      <mat-icon>check</mat-icon>
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>
